import React from 'react';
import CustomWidgetRenderer from 'shared/components/WidgetRenderer';

interface WidgetProps {
  widgets: any[];
  remainingInventoryIds?: string[];
  queryParamsObject?: object;
  pageData?: string;
}

const Widgets = ({
  widgets,
  remainingInventoryIds,
  queryParamsObject,
  pageData,
}: WidgetProps) => {
  if (!(widgets && Array.isArray(widgets) && widgets.length > 0)) {
    return null;
  }
  return (
    <>
      {
        <CustomWidgetRenderer
          widgetList={widgets}
          isServer={__SERVER__}
          pageData={pageData}
          eagerLoadImages={1}
          allWidgetsLength={widgets.length}
          remainingInventoryIds={remainingInventoryIds}
          queryParamsObject={queryParamsObject}
        />
      }
    </>
  );
};

export default Widgets;
